/** @jsx jsx */
import React, { Fragment, useRef } from "react";
import { jsx } from "theme-ui";
import { Box } from "@shared-components/Box/Box";

import { AspectRatio } from "@shared-components/AspectRatio/AspectRatio";
import { BackgroundVideo } from "@shared-components/BackgroundVideo/BackgroundVideo";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Controller } from "swiper";
import "swiper/swiper-bundle.css";
// impor./styles.js.ts"
import MediaSliderArrow from "@svg-icons/media-slider-arrow.component.svg";
import MediaSliderEllipse from "@svg-icons/media-slider-ellipse.component.svg";
import { Icon } from "../../shared/components/Icon/Icon";
import {
  ellipseStyles,
  mediaSliderContainerStyle,
  rightArrowStyles,
  leftArrowStyles,
  rightArrowSpanStyles,
  leftArrowSpanStyles,
  swiperStyles,
} from "./styles";
import { MediaSliderModule } from "../../carlsberg-headless/types/modules/MediaSlider";
import { UmbracoBackgroundImage } from "../../shared/components/Image/UmbracoBackgroundImage/UmbracoBackgroundImage";

SwiperCore.use([Controller, Navigation, Pagination]);
export type MediaSliderModuleProps = MediaSliderModule;

const MediaSlider: React.FC<MediaSliderModuleProps> = ({ ...props }) => {
  const swiperInstance = useRef<SwiperCore>();

  const initSwiper = (swiper: SwiperCore) => {
    swiperInstance.current = swiper;
  };

  const gotoPrev = () => {
    if (swiperInstance.current) {
      swiperInstance.current.slidePrev();
    }
  };

  const gotoNext = () => {
    if (swiperInstance.current) {
      swiperInstance.current.slideNext();
    }
  };

  return (
    <Box
      key={props.cbKey}
      sx={mediaSliderContainerStyle}
      variant="mediaSlider.container"
    >
      <Box sx={swiperStyles}>
        <Swiper
          effect="fade"
          pagination={{
            clickable: true,
            el: `.swiper-pagination-${props.cbKey}`,
          }}
          navigation={{
            nextEl: `.swiper-button-next-${props.cbKey}`,
            prevEl: `.swiper-button-prev-${props.cbKey}`,
          }}
          loop
          speed={500}
          onSwiper={(swiper) => initSwiper(swiper)}
        >
          {props.slides &&
            props.slides.map((slide, index) => (
              <SwiperSlide key={`${index}_${slide.cbKey}` || 0}>
                <Box>
                  <AspectRatio ratio={["1:1", "16:9"]} sx={{ bg: "darkGreen" }}>
                    {slide.video && slide.video.fullUrl && (
                      <BackgroundVideo src={slide.video.fullUrl} />
                    )}
                    {!slide.video && slide.image && slide.image.fullUrl && (
                      <UmbracoBackgroundImage
                        image={slide.image}
                        width={[314, 714, 800]}
                        height={[314, "auto", "auto"]}
                      />
                    )}
                  </AspectRatio>
                </Box>
              </SwiperSlide>
            ))}
          {props.slides && (
            <Fragment>
              <button
                className={`swiper-button-prev swiper-button-prev-${props.cbKey}`}
                onClick={() => gotoPrev()}
              >
                <Box sx={leftArrowSpanStyles}>
                  <Icon sx={leftArrowStyles} svg={MediaSliderArrow} />
                </Box>
                <Icon sx={ellipseStyles} svg={MediaSliderEllipse} />
              </button>
              <button
                className={`swiper-button-next swiper-button-next-${props.cbKey}`}
                onClick={() => gotoNext()}
              >
                <Box sx={rightArrowSpanStyles}>
                  <Icon sx={rightArrowStyles} svg={MediaSliderArrow} />
                </Box>
                <Icon sx={ellipseStyles} svg={MediaSliderEllipse} />
              </button>
            </Fragment>
          )}
        </Swiper>
        <div
          className={`swiper-pagination swiper-pagination-${props.cbKey}`}
        ></div>
      </Box>
    </Box>
  );
};

export { MediaSlider };
